import React from "react";
import styles from "./MobileMenuButton.module.scss";

interface MobileMenuButtonProps {
  onClick: () => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
  className?: string;
}

export const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({
  onClick,
  buttonRef,
  className = "",
}) => {
  return (
    <button
      ref={buttonRef}
      className={`${styles.mainMenuButton} ${className}`}
      onClick={onClick}
      aria-label="Открыть меню"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
};

